import { Pipe, PipeTransform } from '@angular/core';
import { DeviceStaticDataService } from '@shared/services/device-static-data.service';

@Pipe({
  name: 'join',
})
export class JoinPipe implements PipeTransform {
  transform(items: any[], sep?: string): string {
    console.log(items);
    if (!items?.length) {
      if (Array.isArray(items)) {
        return '';
      }
      return items as unknown as string;
    }
    return items.filter((item) => item != null && item !== '').join(sep || ', ');
  }
}
